import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IInitialState {
    showGuideLines: boolean;
}

const initialState: IInitialState = {
    showGuideLines: false
};

const showGuidelinesSlice = createSlice({
    name: 'showGuidelines',
    initialState: initialState,
    reducers: {
        toggleShowGuidelines: (state) => {
            state.showGuideLines = !state.showGuideLines;
        },
        setShowGuidelines: (state, action: PayloadAction<boolean>) => {
            state.showGuideLines = action.payload;
        }
    }
});

export const ShowGuidelinesActions = showGuidelinesSlice.actions;
export const ShowGuidelinesReducer = showGuidelinesSlice.reducer;
